module.exports = __webpack_public_path__ + "static/media/Ben_Gravy2x.3e0b13cc.png";